import dayjs from 'dayjs'
import { IDefaultLink } from '../../../../api/types'
import { TTableDataCountDisplay, TTableHeader } from '@reapitform/common-ui'

const tableHeader: TTableHeader<IDefaultLink>[] = [
  {
    headerTitle: 'FORM',
    key: 'formType',
    sortable: true,
    sortAs: 'FormType',
    columnWidth: '250px',
  },
  {
    headerTitle: 'TITLE',
    key: 'title',
  },
  {
    headerTitle: 'URL',
    key: 'url',
  },
  {
    headerTitle: 'Last Updated',
    key: 'lastUpdatedUTC',
    getColumnValue: (data) => dayjs(data.lastUpdatedUTC).format('D MMM YYYY'),
    sortable: true,
    sortAs: 'LastActionDate',
    columnWidth: '140px',
  },
]

const tableCountDisplayConfig: TTableDataCountDisplay = {
  singular: 'Link',
  plural: 'Links',
}

export const linkTableConfig = {
  header: tableHeader,
  countDisplay: tableCountDisplayConfig,
  emptyMessages: 'There are no default links',
  description: 'Links will be added to the form by default and emailed to the recipient with their agreement.',
}
